var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.145,32.358c0-1.07-0.416-2.075-1.17-2.828l-7.504-7.505c-1.561-1.559-4.097-1.559-5.657,0L22.025,60.813 c-1.559,1.56-1.559,4.098,0,5.657l7.504,7.504c0.754,0.754,1.758,1.17,2.828,1.17c1.07,0,2.075-0.416,2.828-1.17l6.714-6.714 c0.001-0.001,0.002-0.001,0.002-0.002s0.001-0.002,0.002-0.002l6.336-6.336c0.001-0.001,0.001-0.001,0.002-0.001 s0.001-0.001,0.001-0.002l12.674-12.674c0,0,0.001,0,0.001-0.001s0-0.001,0.001-0.001l6.339-6.339c0,0,0,0,0,0s0,0,0,0l6.715-6.715 C74.729,34.433,75.145,33.428,75.145,32.358z M30.944,72.561l1.414-1.414c0,0,0,0,0.001,0.001L30.944,72.561z M65.844,37.659 l-2.164-2.164c-0.781-0.78-2.047-0.781-2.828,0s-0.781,2.047,0,2.829l2.164,2.163l-3.511,3.511l-2.163-2.164 c-0.781-0.781-2.047-0.781-2.828,0c-0.781,0.781-0.781,2.047,0,2.829l2.163,2.163l-3.511,3.51l-2.164-2.164 c-0.781-0.781-2.048-0.781-2.828,0c-0.781,0.781-0.781,2.047,0,2.828l2.163,2.163l-3.511,3.51l-2.163-2.162 c-0.781-0.781-2.047-0.781-2.829,0c-0.781,0.781-0.781,2.048,0,2.828l2.162,2.162l-3.511,3.511l-2.161-2.162 c-0.781-0.781-2.047-0.781-2.829,0c-0.781,0.78-0.781,2.047,0,2.828l2.161,2.162l-5.302,5.301l-7.501-7.501l38.789-38.788 l7.504,7.504L65.844,37.659z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/ruler.158600db88793162ff43627d8367c84d.svg";
export { ForwardRef as ReactComponent };